import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    FormControlLabel, Checkbox, FormControl, Button,
    FormGroup, TextField, CircularProgress, makeStyles, Radio, RadioGroup
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { dateFormatter } from '../../Models/CommonFunc'
import classNames from 'classnames';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import CustomAlert from '../../CustomAlert';
import mapValues from 'lodash/mapValues';
import { Helmet } from 'react-helmet';
import { getPartyDocumentWithUniqueId, updatePartyDocument } from '../../../Backend/firebase/party';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function UpdateParty({ _id, partyId, setOpenPopup, refreshData }) {
    const classes = useStyles();
    const { register, handleSubmit, errors, reset, setValue } = useForm();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();

    useEffect(async () => {
        try {
            const getProducts = await getPartyDocumentWithUniqueId(partyId);
            setTimeout(() => {
                mapValues(getProducts[0], (value, key) => setValue(key, value));
            });
        } catch(error) {
            console.log("Error Occur in Update Product", error)
        }
    }, []);


    const onSubmit = async (data) => {
        setIsLoading(true);
        var newParty = {};
        newParty._id = _id;
        newParty.uniqueId = partyId;
        newParty.userId = userData.uid;
        newParty.PartyName = data.PartyName;
        newParty.PartyType = data.PartyType;
        newParty.Address = data.Address;
        newParty.City = data.City;
        newParty.Pincode = data.Pincode;
        newParty.MobileNumber = data.MobileNumber;
        newParty.Email = data.Email;
        newParty.DrugLicense = data.DrugLicense;
        newParty.GSTNo = data.GSTNo;
        newParty.FSSAINo = data.FSSAINo;
        newParty.OverDue = data.OverDue;
        newParty.LastPayment = data.LastPayment;
        try {
            var party = updatePartyDocument(newParty);
            if (party) {
                setOpenPopup(false);
                setNotificationMessage('Party Updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
                setIsLoading(false);
                refreshData()
                // setTimeout(routeToPages, 2000);
            } else {
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-party');
            }
        }  catch (error) {
            console.error(error);
            setNotificationMessage('Something went wrong, Please try again later!!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
            history.push('/retailer/create-party');
        }
    };

    const routeToPages = () => {
        history.push('/retailer/parties');
    }

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update party." />
                    <title>Update Party | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                Party Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.PartyName })}
                                    name="PartyName" autoComplete="none"
                                    ref={register({ required: 'Please enter Party Name!' })} />
                                <small className="form-text text-danger">{errors.PartyName && errors.PartyName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Party Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.PartyType })} 
                                    aria-label="Default select example"
                                    name="PartyType" ref={register({
                                        required: 'Please select Party Type!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Party Type!'
                                        }
                                    })} defaultValue="Select Party Type" >
                                    <option value={'Client'}>{'Client'}</option>
                                    <option value={'Vendor'}>{'Vendor'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.PartyType && errors.PartyType.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Mobile Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MobileNumber })}
                                    name="MobileNumber" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter MobileNumber!' })} />
                                    <small className="form-text text-danger">{errors.MobileNumber && errors.MobileNumber.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Email <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Email })}
                                    name="Email" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Email!' })} />
                                    <small className="form-text text-danger">{errors.Email && errors.Email.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Address })}
                                    name="Address" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Address!' })} />
                                    <small className="form-text text-danger">{errors.Address && errors.Address.message}</small>
                            </div>
                            <div className="col-md-3 mb-2">
                                City <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.City })}
                                    name="City" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter City!' })} />
                                    <small className="form-text text-danger">{errors.City && errors.City.message}</small>
                            </div>
                            <div className="col-md-3 mb-2">
                                Pincode <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Pincode })}
                                    name="Pincode" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Pincode!' })} />
                                    <small className="form-text text-danger">{errors.Pincode && errors.Pincode.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Drug License
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="DrugLicense" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-4 mb-2">
                                GST No
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="GSTNo" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-4 mb-2">
                                FSSAI No
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="FSSAINo" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Payment Over Due <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="number" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.OverDue })}
                                    name="OverDue" autoComplete="none"
                                    ref={register({ required: 'Please enter Payment OverDue!' })} />
                                    <small className="form-text text-danger">{errors.OverDue && errors.OverDue.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Last Payment <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="number" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.LastPayment })}
                                    name="LastPayment" autoComplete="none"
                                    ref={register({ required: 'Please enter Last Payment!' })} />
                                    <small className="form-text text-danger">{errors.LastPayment && errors.LastPayment.message}</small>
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Update Party'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateParty
